import "./player.scss";

function player({player}) {
    return (
        <div className="player-container">
            <div className="flex-row">
                <p className="player-title">{player.name}</p> 
                <p className="player-stat">{player.ppg.toFixed(2)}</p>
                <p className="player-stat">{player.rpg.toFixed(2)}</p>
                <p className="player-stat">{player.apg.toFixed(2)}</p>
            </div>
        </div>
    )
}

export default player;